import { EmptyStateTenantsIllustration } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { Level1EmptyStateLayout } from "~/components/GettingStarted/Level1EmptyStateLayout";
import ExternalLink from "~/components/Navigation/ExternalLink/ExternalLink";
import { AddTenant } from "./AddOrCloneTenant";
const Onboarding = () => (<Level1EmptyStateLayout title={"Tenants"} intro={"Use Tenants to deploy your projects to multiple end-customers, with the software tailored to each specific customer."} actionButtonsAndLinks={[<AddTenant />, <ExternalLink href="MultiTenantDeployments">Learn more</ExternalLink>]} image={<EmptyStateTenantsIllustration />}/>);
export default Onboarding;
